import axios from 'axios'
const BASE_URL = `${window.location.protocol}//${window.location.hostname}:5000/`;
console.log(BASE_URL);
const axiosInstance = axios.create({
	baseURL: BASE_URL,
	headers: {
		'Content-Type': 'application/json'
	}
});
const api = {
	async getInterview(id, token) {
		return axiosInstance.post('/getInterview', {
			"interview_id": id,
			"token": token,
		});
	},
	
	async getInterviews(token) {
		const {data} = await axiosInstance.post('/getInterviews', {
			token: token
		});
		
		if (data.status === "SUCCESS") {
			return data.data;
		} else {
			throw new Error("An error occured! Please try again!");
		}
	},
	async saveInterview(job_title, job_description, hard_questions, soft_questions, usersCanSeeAnswers, userCanVoteMultipleTimes, token) {
		const {data} = await axiosInstance.post('/saveInterview', {
			"job_title": job_title,
			"job_description": job_description,
			"hard_questions": hard_questions,
			"soft_questions": soft_questions,
			"token": token,
			"usersCanSeeAnswers": usersCanSeeAnswers,
			"userCanVoteMultipleTimes": userCanVoteMultipleTimes,
		});
		
		if (data.status === "SUCCESS") {
			return data.data;
		} else {
			throw new Error("An error occured! Please try again!");
		}
	},
	async getQuestions(job_title, job_description, hard_skills, soft_skills) {
		const {data} = await axiosInstance.post('/generateQuestions', {
			"job_title": job_title,
			"job_description": job_description,
			"hard_skills": hard_skills,
			"soft_skills": soft_skills,
		});
		if (data.status === "SUCCESS") {
			return data.data;
		} else {
			throw new Error("An error occured! Please try again!");
		}
	},
	
	async getSkills(job_title, job_description) {
		const {data} = await axiosInstance.post('/generateSkills', {
			"job_title": job_title,
			"job_description": job_description,
		});
		
		if (data.status === "SUCCESS") {
			return data.data;
		} else {
			throw new Error("An error occured! Please try again!");
		}
	},
	async evaluateCandidate(d) {
		return await axiosInstance.post('/evaluateCandidate', d);
	},
	async getEvaluations(interview_id, token) {
		return await axiosInstance.post('/getEvaluations', { token: token, interview_id: interview_id });
	},
	async getEvaluation(id, token) {
		return await axiosInstance.post('/getEvaluation', { evaluation_id: id, token: token});
	},
	async login(email, password) {
		return await axiosInstance.post('/login', { email: email, password: password });
	},
	async register(email, password, type, name, surname) {
		return await axiosInstance.post('/register', { email: email, password: password, type: type, name:name, surname: surname });
	},
	async googleLogin(token, type) {
		return await axiosInstance.post('/googleLogin', {token: token, type: type});
	},
	async updateProfile(token, changes) {
		return await axiosInstance.post('/updateProfile', {token: token, changes: changes});
	},
	async checkIfStillLogged(token) {
		return await axiosInstance.post('/checkIfStillLogged', { token: token});
	},
	async checkVerificationCode(token, verificationCode) {
		return await axiosInstance.post('/checkVerificationCode', { token: token, verificationCode: verificationCode });
	}
}

export default api;